import { slotBarSymbolNames } from './resources';

export const iconsData = {
  // '0': {file: 'emptyIcon.png', infoName:"symbol0", infoKey:'0'},
  1: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  2: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  3: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  4: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  5: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  6: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  7: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  8: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  9: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  10: {
    file: 'symbol2.json',
    infoName: 'symbol2',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
  400: {
    file: 'skeleton.json',
    infoName: 'JackpotSymbol',
    winAnimationReversed: false,
    infoKey: '1',
    infoFrame: /static/,
    key: 'icons',
    idleFrame: 'idle',
    noWinFrame: 'noWin',
    blurFrame: 'fan_idle_blur',
  },
};
export const iconStates = {
  idle: 'idle',
  inactive: 'inactive',
  win: 'win',
  noWin: 'no_win',
  idleSmallCenter: 'idleSmallCenter',
  idleSmallDw: 'idleSmallDw',
  idleSmallUp: 'idleSmallUp',
  idleBigCenter: 'idleBigCenter',
  idleBigDw: 'idleBigDw',
  idleBigUp: 'idleBigUp',
  spin: 'spin',
  wined: 'wined',
  stop: 'stop',
};

export const iconsIds = {
  1: slotBarSymbolNames.seven,
  2: slotBarSymbolNames.grape,
  3: slotBarSymbolNames.watermelon,
  4: slotBarSymbolNames.bell,
  5: slotBarSymbolNames.plum,
  6: slotBarSymbolNames.orange,
  7: slotBarSymbolNames.cherry,
  8: slotBarSymbolNames.lemon,
  9: slotBarSymbolNames.wildWeed,
  10: slotBarSymbolNames.dollar,
  11: slotBarSymbolNames.star,
};

export const iconsName = {
  [slotBarSymbolNames.seven]: 1,
  [slotBarSymbolNames.grape]: 2,
  [slotBarSymbolNames.watermelon]: 3,
  [slotBarSymbolNames.bell]: 4,
  [slotBarSymbolNames.plum]: 5,
  [slotBarSymbolNames.orange]: 6,
  [slotBarSymbolNames.cherry]: 7,
  [slotBarSymbolNames.lemon]: 8,
  [slotBarSymbolNames.wildWeed]: 9,
  [slotBarSymbolNames.dollar]: 10,
  [slotBarSymbolNames.star]: 11,
};
// export const iconStates = {
//     idle:1,
//     spin:2,
//     win:3,
//     noWin:4
// };

export const specialIcons = {};

// eslint-disable-next-line no-restricted-syntax, guard-for-in
for (const iconNumber in iconsData) {
  const d = iconsData[iconNumber];
  // eslint-disable-next-line default-case
  switch (d.file) {
    case 'scatterIcon.json':
      specialIcons.scatter = Number(iconNumber);
      break;
    // case 'bonefire.json':
    //     specialIcons.moneyIcon = iconNumber;
    //     break;
    case 'wildIcon.json':
      specialIcons.wild = Number(iconNumber);
      break;
    // case 'emptyIcon.png':
    //     specialIcons.emptyIcon = Number(iconNumber);
    //     break;
  }
}
